import { z } from "zod";

export enum EDiscomfortType {
  COLD = "COLD",
  HOT = "HOT",
}

export const discomfortTypeDtoSchema = z.nativeEnum(EDiscomfortType);
